import axios from "../../utils/axios";

export const getTransactions = async () => {
    const response = await axios.get("/transactions");
    return response.data;
};
//get filter 

export const getFilteredTransactions = async ({pageNumber,itemNoPerPage,type="",productName=""}) => {
    let queryUrl= `/transactions?_page=${pageNumber}&_limit=${itemNoPerPage}`
    if(type !== ""){
        queryUrl = queryUrl+`&type=${type}`
    }
    if(productName!==""){
        queryUrl = queryUrl+`&name_like=${productName}`
    }
    const response = await axios.get(queryUrl);
    return response.data;
};


export const addTransaction = async (data) => {
    const response = await axios.post("/transactions", data);
    return response.data;
};

export const editTransaction = async (id, data) => {
    const response = await axios.put(`/transactions/${id}`, data);

    return response.data;
};

export const deleteTransaction = async (id) => {
    const response = axios.delete(`/transactions/${id}`);

    return response.data;
};
